module.exports = __webpack_public_path__ + "img/refresh.92e3c2b9.svg";